/**
 * VisionForge — Hugging Face Xet bucket for app durable data (Binder pattern).
 *
 *   hf sync ./data hf://buckets/copperscout1/visionforge-user
 *
 * Local mirror: visionforge/data/
 * Sync: npm run hf:sync | hf:pull
 *
 * One shared app bucket only — never create visionforge-u-* per-user buckets
 * or misspelled ids (e.g. vissionforge-user).
 * Multi-tenant isolation (if needed) = path prefixes under ./data/user/{key}/.
 */

export const VISIONFORGE_HF_BUCKET = "copperscout1/visionforge-user";
export const VISIONFORGE_HF_BUCKET_URI = `hf://buckets/${VISIONFORGE_HF_BUCKET}`;

/** Local shelves under ./data (mirrored to the bucket). */
export const VISIONFORGE_DATA_SHELVES = [
  "bindings",
  "sessions",
  "clips",
  "uploads",
  "exports",
  "meta",
  "engines",
] as const;

export type VisionforgeDataShelf = (typeof VISIONFORGE_DATA_SHELVES)[number];

export function visionforgeBucketSyncPushCmd(localDir = "./data"): string {
  return `hf sync ${localDir} ${VISIONFORGE_HF_BUCKET_URI}`;
}

export function visionforgeBucketSyncPullCmd(localDir = "./data"): string {
  return `hf sync ${VISIONFORGE_HF_BUCKET_URI} ${localDir}`;
}
